import CardCreateSignerContacts from "components/card-send-create/card-create-signers/card-create-signer-contacts";
import CardCreateSignerLink from "components/card-send-create/card-create-signers/card-create-signer-link";
import CardCreateSignerManual from "components/card-send-create/card-create-signers/card-create-signer-manual";
import CardCreateSignerOptions from "components/card-send-create/card-create-signers/card-create-signer-options";
import { PropTypes } from "prop-types";
import React, { useState } from "react";

const CardCreateSigners = ({ className, header, footer, focusRef, cardSend, withSignersList, setShowAuthwallPopup, onChange, onErrors }) => {
  const [signerStep, setSignerStep] = useState("options");

  const onFinish = () => {
    setSignerStep("options");
  };

  if (signerStep === "options") {
    return (
      <>
        {header}
        <div className={className}>
          <CardCreateSignerOptions
            focusRef={focusRef}
            cardSend={cardSend}
            withSignersList={withSignersList}
            setSignerStep={setSignerStep}
            setShowAuthwallPopup={setShowAuthwallPopup}
            onChange={onChange}
            onErrors={onErrors}
          />
        </div>
        {footer}
      </>
    );
  }

  if (signerStep === "contacts") {
    return (
      <div className={`${className} subsection`}>
        <CardCreateSignerContacts cardSend={cardSend} onChange={onChange} onErrors={onErrors} onFinish={onFinish} />
      </div>
    );
  }

  if (signerStep === "link") {
    return (
      <div className={`${className} subsection`}>
        <CardCreateSignerLink cardSend={cardSend} onFinish={onFinish} />
      </div>
    );
  }

  if (signerStep === "manual") {
    return (
      <div className={`${className} subsection`}>
        <CardCreateSignerManual cardSend={cardSend} onChange={onChange} onErrors={onErrors} onFinish={onFinish} />
      </div>
    );
  }
};

CardCreateSigners.propTypes = {
  className: PropTypes.string,
  header: PropTypes.node,
  footer: PropTypes.node,
  focusRef: PropTypes.object,
  cardSend: PropTypes.object.isRequired,
  setShowAuthwallPopup: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onErrors: PropTypes.func.isRequired,
  withSignersList: PropTypes.bool,
};

export default CardCreateSigners;
